module.exports = __webpack_public_path__ + "img/song.05613823.svg";